import { DropDownButton, DropdownItem, IconName } from '@optimus-web/core';
import { ChartCardActions } from '../../types';

export interface ActionsProps {
    actions: ChartCardActions;
    id: string;
}

export const ActionsMenu = ({ actions, id }: ActionsProps) => (
    <DropDownButton size="small" variant="tertiary" icon={IconName.More} aria-label={`card-actions-menu-${id}`}>
        {actions.map(({ label, id: actionId, callback }) => (
            <DropdownItem key={actionId} label={label} value={actionId} onClick={() => callback(actionId)} />
        ))}
    </DropDownButton>
);
